import { CustomBlock } from 'ngx-blockly-new';

export class GameStateBlock extends CustomBlock {
  constructor() {
    super('tictactoe_gamestate');
    this.class = GameStateBlock;
  }

  public defineBlock() {
    this.block.appendDummyInput().appendField('Board');
    this.block.setOutput(true, 'Array');
    this.block.setColour(270);
    this.block.setTooltip(
      'Outputs a two-dimensional list of chars on the tic tac toe board'
    );
    this.block.setHelpUrl('https://app.codecraftworks.com/courses/33629');
  }

  public toPythonCode(): string | any[] {
    return ['self.get_game_state()', 99];
  }
}
